import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, PregnancyMoodModal } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { usePatientId } from "@madmedical/user";
import { useCreatePregnancyWellBeingMutation } from "../api";
const PregnancyMoodModalForm = ({ open, onClose }) => {
    const { patientId } = usePatientId();
    const [createPregnancyWellBeing] = useCreatePregnancyWellBeingMutation();
    return (_jsx(Modal, Object.assign({ open: open, onClose: onClose, size: "sm" }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                createdAt: new Date().toISOString(),
                patientId,
                status: undefined,
                symptoms: [],
                comment: "",
            }, mutation: createPregnancyWellBeing, resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(PregnancyMoodModal, { onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess })) })) })));
};
export default PregnancyMoodModalForm;
